
import CompExample from "./EmailCard"
import { Stack, Switch } from '@chakra-ui/react'
export default function Email() {
    return (
        <div className="w-full ">
            <div className="w-8/12 px-5 py-5">
                <div>
                    <CompExample />
                </div>
                <h3 className="mt-3 text-2xl font-semibold">Subscriptions</h3>
                <div className="mt-4 py-4 border px-4 rounded-lg shadow-md flex justify-between items-center">
                    <div>
                        <h5 className="text-2xl font-semibold">Job and company alerts</h5>
                        <p className="text-black">
                            Emails about new jobs matching your job searches and companies you follow </p>
                    </div>
                    <i class="fa-solid fa-arrow-right"></i>
                </div>
                <div className="mt-5">
                    <h3 className="text-2xl font-semibold">Employer and recruiter emails</h3>
                    <div className="mt-4 border py-3 rounded-lg px-3 shadow-md ">
                        <div className="w-full flex justify-between items-center">
                            <div>
                                <h5>CV contacts</h5>
                                <p className="text-black">Messages from employers and recruiters interested in your CV</p>
                            </div>
                            <div>
                                <button className="px-3 border py-2 rounded-md font-medium text-blue-600 
                            ">Change</button>
                            </div>
                        </div>
                        <div className="flex">
                            <i class="fa-solid fa-circle-exclamation text-sm"></i>
                            <p className="text-sm text-black opacity-85 ml-2">To stop receiving these messages, adjust your CV Privacy Settings</p>
                        </div>
                    </div>
                </div>
                <div className="w-full mt-5">
                    <h3 className="text-2xl font-semibold">Additional emails</h3>
                    <div className="mt-4">
                        <div className=" px-3 py-3 border-t-2 flex justify-between items-center">
                            <div>
                                <h5 className="text-lg">Application and account status</h5>
                                <p className="text-base text-black opacity-90">Updates on your active job applications and Indeed account</p>
                            </div>
                            <div>
                                <Stack align='center' direction='row'>
                                    {/* <Switch size='sm' /> */}
                                    <Switch size='md' />
                                    {/* <Switch size='lg' /> */}
                                </Stack>
                            </div>
                        </div>
                        <div className=" px-3 py-3 border-t-2 flex justify-between items-center">
                            <div>
                                <h5 className="text-lg">Application and account status</h5>
                                <p className="text-base text-black opacity-90">Updates on your active job applications and Indeed account</p>
                            </div>
                            <div>
                                <Stack align='center' direction='row'>
                                    {/* <Switch size='sm' /> */}
                                    <Switch size='md' />
                                    {/* <Switch size='lg' /> */}
                                </Stack>
                            </div>
                        </div>
                        <div className=" px-3 py-3 border-t-2 flex justify-between items-center">
                            <div>
                                <h5 className="text-lg">Application and account status</h5>
                                <p className="text-base text-black opacity-90">Updates on your active job applications and Indeed account</p>
                            </div>
                            <div>
                                <Stack align='center' direction='row'>
                                    {/* <Switch size='sm' /> */}
                                    <Switch size='md' />
                                    {/* <Switch size='lg' /> */}
                                </Stack>
                            </div>
                        </div>
                        <div className=" px-3 py-3 border-t-2 border-b-2 flex justify-between items-center">
                            <div>
                                <h5 className="text-lg">Application and account status</h5>
                                <p className="text-base text-black opacity-90">Updates on your active job applications and Indeed account</p>
                            </div>
                            <div>
                                <Stack align='center' direction='row'>
                                    {/* <Switch size='sm' /> */}
                                    <Switch size='md' />
                                    {/* <Switch size='lg' /> */}
                                </Stack>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-4 mt-5 shadow px-4 border rounded-lg">
                    <p className="text-gray-700 text-lg ">Want to get fewer emails from us?</p>
                    <h5>Unsubscribe from all commercial emails</h5>
                    <p className="text-sm text-black opacity-60 font-medium">Indeed may still send you emails for confirmations and other messages relevant to how you interact with Indeed. You can unsubscribe from job alert, company alert and daily job feed subscriptions by updating your individual preferences on the Job and company alerts page.</p>
                </div>
            </div>

        </div>
    )
}

